module.exports = __webpack_public_path__ + "static/media/39_B.ea9e6cd9.png";